import DefaultPageModal from './DefaultPageModal'

export default DefaultPageModal
